module.exports = __webpack_public_path__ + "img/step2.e49bac0e.jpeg";